module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-header.a527c298.png";